import { useTranslation } from 'react-i18next';
import Style from './style';
import Navbar from '../../Navbar';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';
import { datastakeApps, noDatastakeApps } from '../../../constants/apps';
import NotFound from '../../NotFound';
import { useEffect, useMemo, useState } from 'react';

const getShuffleArray = () => {
  const array = [1, 2, 3];

  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }

  return array;
};

const AuthLayout = ({
  children,
  title = 'Welcome Back',
  subTitle = 'Please introduce yourself',
  app: _app = 'mmt',
  rightClassName,
  step,
}) => {
  const { t } = useTranslation();
  const app = process.env.REACT_APP_APP || _app;
  const [randomIndexes, setRandomIndexes] = useState([]);

  const getClassName = () => {
    if (app === 'tif') {
      return 'tif-layout';
    }

    if (app === 'tazama') {
      return 'tazama-layout';
    }
  };

  const getLogo = () => {
    if (app === 'tif') {
      return "/assets/images/applications/tif-logo.svg"
    }

    if (app === 'tazama') {
      return "/assets/images/applications/tazama-logo.svg"
    }

    return "/assets/images/applications/mmt-logo-2.svg";
  };

  useEffect(() => {
    setRandomIndexes(p => {
      if (p.length <= 1) {
        return getShuffleArray();
      }

      return p.filter((_, i) => i !== 0);
    });
  }, [step]);

  const randomNumber = useMemo(() => {
    return randomIndexes[0];
  }, [randomIndexes]);

  const getRightImageClassName = () => {
    if (app === 'tif') {
      return 'is-tif';
    }

    if (app === 'tazama') {
      return `is-tazama-${randomNumber}`;
    }

    return 'default';
  };

  if (!process.env.REACT_APP_APP) {
    if (!datastakeApps.includes(app)) {
      return <NotFound />;
    }
  }

  return (
    <>
      <Navbar back={false} app={noDatastakeApps.includes(app) ? app : undefined} />
      <Style className={getClassName()}>
        <div className="main-cont">
          <div className="d-cont left">
            <div className='main'>
              <div className='left-header'>
                <img
                  className="app-logo"
                  src={getLogo()}
                  alt="mmt" />
                <h2>{t(title)}</h2>
                <p>
                  {typeof subTitle === 'string' ? t(subTitle) : subTitle}
                </p>
              </div>
              {children}
            </div>
          </div>
          <div className={formatClassname(["d-cont right", rightClassName])}>
            <div className={formatClassname(['right-img', getRightImageClassName()])} />
          </div>
        </div>
      </Style >
    </>
  );
};

export default AuthLayout;
